import { SentenceSetContextProvider } from '../../containers/SentenceSetContextProvider/entry';
import { SetsSelectedWrapper } from './SetsSelectedWrapper';

export default function SentenceSet(props) {
  return (
    <SentenceSetContextProvider
      setId={props.route?.params?.setId}
      patientId={props.route?.params?.selectedID}
      apiName={props.route?.params?.apiName}
    >
      <SetsSelectedWrapper props={props} />
    </SentenceSetContextProvider>
  );
}
